import React, { useMemo } from 'react';
import type { Waiting } from '../../types/waiting';
import styles from './WaitingSummary.module.css';

interface WaitingSummaryProps {
  waitings: Waiting[];
}

export default function WaitingSummary({ waitings }: WaitingSummaryProps) {
  const counts = useMemo(() => {
    const result = { waiting: 0, called: 0, seated: 0, noShow: 0 };
    for (const w of waitings) {
      switch (w.status) {
        case 'WAITING':
          result.waiting++;
          break;
        case 'CALLED':
          result.called++;
          break;
        case 'SEATED':
          result.seated++;
          break;
        case 'NO_SHOW':
          result.noShow++;
          break;
      }
    }
    return result;
  }, [waitings]);

  return (
    <div className={styles.summary}>
      <span className={`${styles.item} ${styles.waiting}`}>
        대기 <span className={styles.value}>{counts.waiting}</span>팀
      </span>
      <span className={`${styles.item} ${styles.called}`}>
        호출 <span className={styles.value}>{counts.called}</span>팀
      </span>
      <span className={`${styles.item} ${styles.seated}`}>
        입장 <span className={styles.value}>{counts.seated}</span>
      </span>
      <span className={`${styles.item} ${styles.noShow}`}>
        노쇼 <span className={styles.value}>{counts.noShow}</span>
      </span>
    </div>
  );
}
